import { Resizable } from "re-resizable";
import React from "react";
import Draggable from "react-draggable";

import "../../../assets/sinner_css/DropCheckbox.css";
import Checkbox from "../../../assets/sinner/check-box.png";

/**
 * checkbox component for drag and drop.
 * @param {*} param0
 * @returns
 */
function DropCheckbox({
  onElementDelete,
  elt,
  defaultPosition = { x: 50, y: 50 },
  signer,
  setSelectedInputField,
  selectedInputField,
  onStop,
}) {
  const fieldId = elt.id || 0;

  const selectedStyle = {
    background: selectedInputField?.id === fieldId ? "red" : "white",
  };
  const focusedStyle = {
    position: "absolute",
    background: "#dfdfdf",
    border:
      selectedInputField?.id === fieldId ? "2px solid red" : "1px solid black",
  };
  return (
    <Draggable
      bounds='.pdfBg'
      defaultPosition={defaultPosition}
      handle='.dragArea'
      onStop={(x, y) => {
        elt.positionFromParentLeft = y.x;
        elt.positionFromParentTop = y.y;

        setSelectedInputField(elt);
        onStop(elt, selectedInputField);
      }}>
      <div style={focusedStyle} title={`${signer.name}'s Input`}>
        <Resizable
          defaultSize={{ width: elt.width, height: elt.height }}
          lockAspectRatio={true}
          maxHeight={300}
          maxWidth={300}
          minHeight={16}
          minWidth={16}
          onResizeStop={(x, y, z, size) => {
            elt.width = z.clientWidth;
            elt.height = z.clientHeight;
          }}>
          <div
            className='dragArea dragcheck'
            style={{
              width: "100%",
              backgroundColor: elt.background,
              height: "100%",
              overflow: "hidden",
            }}>
            <p
              className='bhBox'
              style={{
                fontSize: elt.fontSize,
                fontFamily: elt.fontFamily,
              }}>
              <img alt='logo' className='App-logo' src={Checkbox} />
            </p>
          </div>
        </Resizable>

        <div className='dots one' style={selectedStyle}></div>
        <div
          className='closeicon'
          onClick={() => onElementDelete(elt, signer)}
          style={{ backgroundColor: "red", color: "white" }}
          title='Delete'></div>
        <div className='dots three' style={selectedStyle}></div>
        <div className='dots four' style={selectedStyle}></div>
      </div>
    </Draggable>
  );
}

export default DropCheckbox;
